// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d6b51530","276":"357ffa88","302":"c48652b1","313":"25281279","472":"276d96c2"}[chunkId] + ".chunk.js";
};